import { useCallback } from "react";
import type { MouseEvent } from "react";

interface UseTermSelectionOptions {
  onTermSelect?: ((term: string) => void) | undefined;
}

interface UseTermSelectionReturn {
  handleDoubleClick: (text?: string) => void;
  handleDoubleClickEvent: (event: MouseEvent) => void;
  handleClick: () => void;
}

export const useTermSelection = ({
  onTermSelect,
}: UseTermSelectionOptions): UseTermSelectionReturn => {
  const handleDoubleClick = useCallback(
    (text?: string) => {
      if (!onTermSelect) return;

      if (text) {
        onTermSelect(text);
      } else {
        const selection = window.getSelection();
        const selectedText = selection?.toString().trim();
        if (selectedText) {
          onTermSelect(selectedText);
        }
      }
    },
    [onTermSelect]
  );

  const handleDoubleClickEvent = useCallback(
    (event: MouseEvent) => {
      if (!onTermSelect) return;

      const selection = window.getSelection();
      const selectedText = selection?.toString().trim();
      if (selectedText) {
        onTermSelect(selectedText);
      }
    },
    [onTermSelect]
  );

  const handleClick = useCallback(() => {
    if (!onTermSelect) return;

    const selection = window.getSelection();
    const selectedText = selection?.toString().trim();

    if (!selectedText) {
      onTermSelect("");
    }
  }, [onTermSelect]);

  return {
    handleDoubleClick,
    handleDoubleClickEvent,
    handleClick,
  };
};
